import { type ReactNode, useEffect } from "react";

import type { AuthCache } from "../auth-store";
import type { CookieAuthAdapter } from "./adapter";
import { useAuthStore } from "../auth-store";
import { useCookieAuthStore } from "./store";

interface AuthCookieProviderProps {
  adapter: CookieAuthAdapter;
  cache: AuthCache;
  children: ReactNode;
}

export function AuthCookieProvider({
  adapter,
  cache,
  children,
}: AuthCookieProviderProps): ReactNode {
  const initialize = useCookieAuthStore((s) => s.initialize);
  const signOut = useCookieAuthStore((s) => s.signOut);
  const registerSignOut = useAuthStore((s) => s.registerSignOut);

  useEffect(() => {
    initialize(adapter, cache);
  }, [initialize, adapter, cache]);

  useEffect(() => {
    registerSignOut(signOut);
  }, [registerSignOut, signOut]);

  return <>{children}</>;
}
